/* Snowmoji – Interaktionen (Countdown, Slider, Galerie, Produktlogik, Reveal) */
(function () {
  if (window.__snowmoji) { window.__snowmoji.init(document); return; }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lang = document.documentElement.lang || undefined;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }

  /* Reveal beim Scrollen */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.15 }) : null;
  function initReveal(scope) {
    $$('.sm-reveal', scope).forEach(function (el) {
      if (!once(el, 'smRv')) return;
      if (io && !reduce) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* Countdown (nur sichtbar, solange das Enddatum in der Zukunft liegt) */
  function initCountdown(scope) {
    $$('[data-sm-countdown]', scope).forEach(function (el) {
      if (!once(el, 'smCd')) return;
      var end = new Date(el.getAttribute('data-sm-countdown')).getTime();
      if (isNaN(end) || end <= Date.now()) { el.remove(); return; }
      var p = function (n) { return String(n).padStart(2, '0'); };
      function tick() {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (s === 0) { el.remove(); clearInterval(t); return; }
        el.querySelector('[data-d]').textContent = p(Math.floor(s / 86400));
        el.querySelector('[data-h]').textContent = p(Math.floor(s % 86400 / 3600));
        el.querySelector('[data-m]').textContent = p(Math.floor(s % 3600 / 60));
        el.querySelector('[data-s]').textContent = p(s % 60);
      }
      var t = setInterval(tick, 1000); tick();
    });
  }

  /* Vorher/Nachher-Slider */
  function initCompare(scope) {
    $$('[data-sm-compare]', scope).forEach(function (box) {
      if (!once(box, 'smCmp')) return;
      var input = $('input[type=range]', box);
      var set = function () { box.style.setProperty('--pos', input.value + '%'); };
      input.addEventListener('input', set); set();
      if (!reduce && 'IntersectionObserver' in window) {
        var demo = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return; demo.disconnect();
          var v = 50, dir = 1, n = 0;
          var id = setInterval(function () {
            v += dir * 1.6; if (v > 68) dir = -1; if (v < 32 && dir < 0) dir = 1;
            if (++n > 70) { clearInterval(id); v = 50; }
            input.value = v; set();
          }, 16);
          input.addEventListener('pointerdown', function () { clearInterval(id); }, { once: true });
        }, { threshold: 0.6 });
        demo.observe(box);
      }
    });
  }

  /* Produkt */
  function initProduct(sec) {
    if (!once(sec, 'smPr')) return;
    var data = JSON.parse($('[data-sm-data]', sec).textContent);
    var form = $('[data-sm-form]', sec);
    var fmt = function (c) {
      try { return new Intl.NumberFormat(lang, { style: 'currency', currency: data.currency }).format(c / 100); }
      catch (e) { return (c / 100).toFixed(2) + ' ' + data.currency; }
    };
    var idInput = $('[name=id]', form), btn = $('[data-sm-atc]', sec), err = $('[data-sm-err]', sec);
    var stockEl = $('[data-sm-stock]', sec), extras = $('[data-sm-extra]', sec);
    var sticky = $('[data-sm-sticky]', sec);
    var btnLabel = btn.textContent.trim();

    function selected() {
      var out = [];
      $$('[data-sm-opt]', sec).forEach(function (g) {
        var c = $('input:checked', g); out[+g.dataset.smOpt] = c ? c.value : null;
      });
      return out;
    }
    function find(opts) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function qty() { var c = $('[name=qty]:checked', sec); return c ? +c.value : 1; }

    /* Zusätzliche Masken im Bundle (gleiche Größe/Optionen wie Maske #1, eigenes Gesicht) */
    function buildExtras() {
      var n = qty() - 1; var opts = selected();
      var prev = $$('select', extras).map(function (s) { return s.value; });
      extras.innerHTML = '';
      extras.classList.toggle('is-on', n > 0);
      for (var i = 0; i < n; i++) {
        var lab = document.createElement('label');
        lab.textContent = data.maskLabel.replace('{n}', i + 2);
        var sel = document.createElement('select');
        sel.setAttribute('aria-label', lab.textContent);
        data.variants.forEach(function (v) {
          var same = v.options.every(function (o, k) { return k === 0 || o === opts[k]; });
          if (!same) return;
          var o = document.createElement('option'); o.value = v.id; o.textContent = v.options[0];
          if (!v.available) { o.disabled = true; o.textContent += ' – ' + data.soldOut; }
          sel.appendChild(o);
        });
        if (prev[i]) sel.value = prev[i]; else sel.value = idInput.value;
        lab.appendChild(sel); extras.appendChild(lab);
      }
    }

    function update() {
      var v = find(selected()); var q = qty();
      err.textContent = '';
      if (!v) { btn.disabled = true; btn.textContent = data.unavailable; return; }
      idInput.value = v.id;
      /* Preise */
      $$('[data-sm-tier]', sec).forEach(function (t) {
        var n = +t.dataset.smTier, pct = n === 1 ? 0 : (data.tiers[n] || 0);
        var total = Math.round(v.price * n * (100 - pct) / 100);
        $('[data-tp]', t).textContent = fmt(total);
        var old = $('[data-to]', t);
        if (old) old.textContent = pct ? fmt(v.price * n) : '';
        var each = $('[data-te]', t); if (each) each.textContent = fmt(Math.round(total / n));
      });
      var pct = q === 1 ? 0 : (data.tiers[q] || 0);
      var cur = Math.round(v.price * q * (100 - pct) / 100);
      var was = v.compare && v.compare > v.price ? v.compare * q : (pct ? v.price * q : 0);
      $$('[data-sm-price]', sec).forEach(function (e) { e.textContent = fmt(cur); });
      $$('[data-sm-was]', sec).forEach(function (e) { e.textContent = was ? fmt(was) : ''; e.hidden = !was; });
      var save = was ? Math.round((1 - cur / was) * 100) : 0;
      $$('[data-sm-save]', sec).forEach(function (e) { e.textContent = save ? data.save.replace('{n}', save) : ''; e.hidden = !save; });
      /* Verfügbarkeit + echte Lagermenge */
      btn.disabled = !v.available;
      btn.textContent = v.available ? btnLabel : data.soldOut;
      var low = v.available && v.inv !== null && v.inv > 0 && v.inv <= data.lowStock;
      stockEl.classList.toggle('is-on', !!low);
      if (low) stockEl.textContent = data.low.replace('{n}', v.inv);
      var bar = $('[data-sm-bar]', sec);
      if (bar) {
        var showBar = v.available && v.inv !== null && v.inv > 0;
        bar.hidden = !showBar;
        if (showBar) {
          $('.sm-bar__fill', bar).style.width = Math.max(6, Math.min(100, Math.round(v.inv / data.barMax * 100))) + '%';
          $('span', bar).textContent = data.inStock.replace('{n}', v.inv);
        }
      }
      var sb = $('[data-sm-sticky-btn]', sec);
      if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? btnLabel : data.soldOut; }
      /* Galerie auf Varianten-Bild springen */
      if (v.media) showSlide(v.media);
    }

    /* Galerie */
    var slides = $$('[data-sm-slide]', sec), thumbs = $$('[data-sm-thumb]', sec);
    function showSlide(mediaId) {
      var hit = false;
      slides.forEach(function (s) { var on = s.dataset.smSlide == mediaId; s.hidden = !on; hit = hit || on; });
      if (!hit) return;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.dataset.smThumb == mediaId ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(t.dataset.smThumb); }); });

    sec.addEventListener('change', function (e) {
      if (e.target.name === 'qty') buildExtras();
      else if (e.target.closest('[data-sm-opt]')) buildExtras();
      update();
    });

    /* Lieferzeit-Leiste */
    var tr = $('[data-sm-trk]', sec);
    if (tr) {
      var day = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d.toLocaleDateString(lang, { month: 'short', day: 'numeric' }); };
      $('[data-t1]', tr).textContent = day(0);
      $('[data-t2]', tr).textContent = day(data.ship[0]) + ' – ' + day(data.ship[1]);
      $('[data-t3]', tr).textContent = day(data.arrive[0]) + ' – ' + day(data.arrive[1]);
    }

    /* In den Warenkorb */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var items = {}; items[idInput.value] = 1;
      $$('select', extras).forEach(function (s) { items[s.value] = (items[s.value] || 0) + 1; });
      var payload = { items: Object.keys(items).map(function (k) { return { id: +k, quantity: items[k] }; }) };
      btn.disabled = true; btn.textContent = data.adding;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message); return j; }); })
        .then(function () { window.location.href = root + (data.after === 'checkout' ? 'checkout' : 'cart'); })
        .catch(function (x) { err.textContent = x.message || data.error; btn.disabled = false; btn.textContent = btnLabel; });
    });

    /* Sticky-Leiste (Mobil) */
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var gone = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', gone);
      }).observe(btn);
      var sb = $('[data-sm-sticky-btn]', sec);
      if (sb) sb.addEventListener('click', function () { form.requestSubmit(); });
    }

    buildExtras(); update();
  }

  function initClips(scope) {
    var vids = $$('[data-sm-clip] video', scope);
    if (!vids.length || reduce || !('IntersectionObserver' in window)) return;
    var vo = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
    }, { threshold: 0.5 });
    vids.forEach(function (v) { if (once(v, 'smVid')) { v.muted = true; v.loop = true; v.playsInline = true; vo.observe(v); } });
  }

  function init(scope) {
    initClips(scope); initReveal(scope); initCountdown(scope); initCompare(scope);
    $$('[data-sm-product]', scope).forEach(initProduct);
  }
  window.__snowmoji = { init: init };
  var go = function () { init(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
